import styles from "./menu.module.css";
import {
  Breadcrumb,
  Divider,
  Tabs,
  Button,
  Card,
  Form,
  Input,
  Row,
  Col,
  Select,
  Switch,
  Tree,
  Popconfirm,
  Empty,
  Spin,
} from "antd";
import React, { useState, useEffect, dispatch } from "react";
import * as Icon from "react-feather";
import templateContentService from "../../services/template-content-service";
import { useDispatch } from "react-redux";
import appLoaderAction from "../../redux/action/app-loader-action";
import notifyUtitls from "../../utils/notify-utils";
import menuService from "../../services/menu-service";
import SecurityUtils from "../../utils/security-utils";
import constantService from "../../services/constant-service";
import menuPreviewAction from "../../redux/action/menu-action";
import debounce from "lodash/debounce";
import previewService from "../../services/preview-Service";

const { Option } = Select;
const { TabPane } = Tabs;

function onChange(checked) {
  console.log(`switch to ${checked}`);
}

const DebounceSelect = ({ fetchOptions, debounceTimeout = 800, ...props }) => {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = useState([]);
  const fetchRef = React.useRef(0);

  useEffect(() => {
    debounceFetcher();
  }, []);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }

        const newResult = newOptions.map((item) => {
          return {
            value: item.templateId,
            label: item.mainTitle.titleTH,
            key: item.templateId,
          };
        });
        setOptions(newResult);
        setFetching(false);
      });
    };

    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);

  return (
    // labelInValue
    <Select
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
    />
  );
};

const MenuManagement = () => {
  const dispatch = useDispatch();
  const [menus, setMenus] = useState(null);
  const [contentList, setContentList] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selected, setSelected] = useState(null);
  const [condition, setCondition] = useState(null);
  const [currentGroupMenu, setCurrentGroupMenu] = useState(null);
  const [menuType, setMenuType] = useState([]);
  const [template, setTemplate] = useState(null);
  const [templateType, setTemplateType] = useState(null);
  const [form] = Form.useForm();
  const [currentMenuType, setCurrentMenuType] = useState(null);
  const [isDelete, setIsDelete] = useState(false);

  //typeahead seach
  const [pagination, setPagination] = useState({
    currentPage: 1,
    rowPerPage: 999,
    rowCount: 0,
  });

  useEffect(() => {
    async function initData() {
      const { menuType } = await constantService.getMenuType();
      setMenuType(menuType);
    }

    initData();
    doGetContentList(null);
    setCondition("PERSONNEL");
  }, []);

  useEffect(() => {
    if (condition) {
      doInit();
    }
  }, [condition]);

  useEffect(() => {
    if (isDelete && menus) {
      onSaveMenu();
    } else {
      setIsDelete(false);
    }
  }, [menus, isDelete]);

  const doInit = async () => {
    try {
      dispatch(appLoaderAction.enable());

      await doLoadMenu();

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  const doGetContentList = async (keyword) => {
    try {
      const newPaginate = {
        ...pagination,
        currentPage: 1,
      };

      const newCondition = { title: keyword };
      const result = await templateContentService.search(
        newCondition,
        newPaginate
      );
      setContentList(result.list);
      setPagination(result.pagination ? result.pagination : newPaginate);

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  const doLoadMenu = async () => {
    const newPaginate = { ...pagination, currentPage: 1 };
    const newCondition = { groupMenu: condition };

    const result = await menuService.search(newCondition, newPaginate);
    if (result.menu) {
      setCurrentGroupMenu(result.menu.groupMenu);
      const newMenus = await result.menu.menu.map((item) => {
        return getMenuKey(item);
      });

      setMenus(newMenus);
    } else {
      setCurrentGroupMenu(null);
      setMenus([]);
    }
  };

  const getMenuKey = (item) => {
    const { children } = item;
    if (children && children.length > 0) {
      const subMenus = children.map((item) => {
        return getMenuKey(item);
      });
      return {
        key: item.menuId,
        ...item,
        children: [...subMenus],
        status: item.status === "true",
        title: item.menuTitle?.titleTH
          ? item.menuTitle?.titleTH
          : item.menuName,
        menuTitle: {
          titleTH: item.menuTitle?.titleTH
            ? item.menuTitle?.titleTH
            : item.menuName,
          titleEN: item.menuTitle?.titleEN,
        },
      };
    } else {
      return {
        key: item.menuId,
        ...item,
        children: item.menu,
        status: item.status === "true",
        title: item.menuTitle?.titleTH
          ? item.menuTitle?.titleTH
          : item.menuName,
        menuTitle: {
          titleTH: item.menuTitle?.titleTH
            ? item.menuTitle?.titleTH
            : item.menuName,
          titleEN: item.menuTitle?.titleEN,
        },
      };
    }
  };

  const loopMenuValidate = (data, name, callback) => {
    for (let i = 0; i < data.length; i++) {
      const datai = data[i];
      if ((datai.children && datai.children.length === 0) || !datai.menu) {
        if (name === "url" && datai.menuType === "URL" && !datai[name]) {
          return callback(data[i], i, data);
        } else if (
          name === "templateId" &&
          datai.menuType === "CONTENT" &&
          !datai[name]
        ) {
          return callback(data[i], i, data);
        } else if (name !== "templateId" && name !== "url" && !datai[name]) {
          return callback(data[i], i, data);
        }
      }

      if (datai.children) {
        loopMenuValidate(datai.children, name, callback);
      }
    }
  };

  const validateMenu = () => {
    let result = false;
    // if(menus.length === 0){
    //   notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุเมนูอย่างน้อย 1 รายการ');
    // }else{
    let isMenuNameInvalid;
    let isMenuTypeInvalid;
    let isUrlInvalid;
    let isTemplateInvalid;

    loopMenuValidate(menus, "menuName", (item, index, arr) => {
      isMenuNameInvalid = " ชื่อเมนู";
    });

    loopMenuValidate(menus, "menuType", (item, index, arr) => {
      isMenuTypeInvalid = " ประเภท" + item.menuName;
    });

    loopMenuValidate(menus, "url", (item, index, arr) => {
      isUrlInvalid = " URL" + item.menuName;
    });

    loopMenuValidate(menus, "templateId", (item, index, arr) => {
      isTemplateInvalid = " เนื้อหา" + item.menuName;
    });

    let invalidMsg = null;

    if (
      isMenuNameInvalid ||
      isMenuTypeInvalid ||
      isUrlInvalid ||
      isTemplateInvalid
    ) {
      if (!invalidMsg) {
        invalidMsg = "โปรดระบุ";
      }

      invalidMsg += isMenuNameInvalid ? isMenuNameInvalid : "";
      invalidMsg += isMenuTypeInvalid ? isMenuTypeInvalid : "";
      invalidMsg += isUrlInvalid ? isUrlInvalid : "";
      invalidMsg += isTemplateInvalid ? isTemplateInvalid : "";

      if (invalidMsg) {
        notifyUtitls.warning("แจ้งเตือน", invalidMsg + "ให้ครบถ้วนทุกรายการ");
      }
    } else {
      result = true;
    }
    // }
    return result;
  };

  const onSaveMenu = async () => {
    try {
      if (isDelete) {
        setIsDelete(false);
      }
      const values = await form.validateFields();
      if (validateMenu()) {
        try {
          dispatch(appLoaderAction.enable());

          const bean = getSaveBean();

          await menuService.edit({ bean: bean });

          doLoadMenu();

          dispatch(appLoaderAction.disale());
          notifyUtitls.success("สำเร็จ", "บันทึกสำเร็จ");
        } catch (err) {
          notifyUtitls.error(err);
          dispatch(appLoaderAction.disale());
        }
      }
    } catch (errorInfo) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุข้อมูลให้ครบถ้วน");
    }
  };

  const getSaveBean = () => {
    const newMenu = menus.map((item) => {
      return {
        ...item,
        menuName: item.title,
      };
    });

    const bean = { groupMenu: condition, menu: newMenu };

    return bean;
  };

  const onCancelMenu = async () => {
    try {
      dispatch(appLoaderAction.enable());

      await doLoadMenu();

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  const onAddMenu = () => {
    const newMenu = [...menus];

    newMenu.push({
      key: SecurityUtils.uuidv4(),
      title: "เมนู" + newMenu.length,
      menuName: "เมนู" + newMenu.length,
      menuType: "CONTENT",
      url: null,
      templateId: null,
      hasChild: false,
      status: true,
      children: [],
      menuTitle: { titleTH: null, titleEN: null },
    });

    setMenus(newMenu);
  };

  const onRemoveMenu = () => {
    const newMenu = menus.map((item) => {
      return removeMenu(item, selected);
    });

    const removedMenus = newMenu.filter((item) => item !== null);
    setMenus(removedMenus);
    setIsDelete(true);

    setTemplateType(null);
    setSelected(null);
  };

  const removeMenu = (menu, selected) => {
    if (menu.key === selected.key) {
      return null;
    } else {
      if (menu.children && menu.children.length > 0) {
        const children = menu.children.map((item) => {
          return removeMenu(item, selected);
        });

        return {
          ...menu,
          children: [...children.filter((item) => item !== null)],
        };
      } else {
        return menu;
      }
    }
  };

  const replaceMenu = (menu, selected) => {
    if (menu.menuId === selected.menuId) {
      return {
        ...selected,
      };
    } else {
      if (menu.children && menu.children.length > 0) {
        const children = menu.children.map((item) => {
          return replaceMenu(item, selected);
        });
        return {
          ...menu,
          children: [...children],
        };
      } else {
        return menu;
      }
    }
  };

  const onPreview = async () => {
    try {
      dispatch(appLoaderAction.enable());

      const bean = getSaveBean();
      // dispatch(menuPreviewAction.addMenu({bean: bean}));

      // console.log('{bean: bean} ', {bean: bean});

      const result = await previewService.savePreview({
        contentType: -1,
        listBean: { bean: bean },
      });

      setTimeout(() => {
        dispatch(appLoaderAction.disale());
        window.open(
          `/?token=${result.token}`,
          "winname",
          "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no"
        );
      }, 500);
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const onDragEnter = (info) => {
    // console.error(info);
  };

  const loop = (data, key, callback) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].key === key) {
        return callback(data[i], i, data);
      }
      if (data[i].children) {
        loop(data[i].children, key, callback);
      }
    }
  };

  const onDrop = (info) => {
    const dropKey = info.node.props.eventKey;
    const dragKey = info.dragNode.props.eventKey;
    const dropPos = info.node.props.pos.split("-");
    const dropPosition =
      info.dropPosition - Number(dropPos[dropPos.length - 1]);
    let ableUpdate = false;

    const str = JSON.stringify(menus);
    const data = [...JSON.parse(str)];

    //Start Validate
    loop(data, dropKey, (item) => {
      // const parent = item;
      // if (!parent.fixed) {
      ableUpdate = true;
      // }
    });

    if (!ableUpdate) {
      return null;
    }

    // Find dragObject
    let dragObj;
    loop(data, dragKey, (item, index, arr) => {
      arr.splice(index, 1);
      dragObj = item;
    });

    // loopMenu(data, dragKey, (item, index, arr) => {
    // 	arr.splice(index, 1);
    // 	dragObj = item;
    // });

    let isUpdateHasChild = true;

    if (!info.dropToGap) {
      // Drop on the content

      loop(data, dropKey, (item) => {
        if (!item.children) {
          isUpdateHasChild = false;
        }

        item.children = item.children || [];
        // where to insert
        item.children.push(dragObj);
      });

      // loopMenu(data, dropKey, (item) => {
      // 	// if (!item.menu) {
      // 	// 	isUpdateHasChild = false;
      // 	// }

      // 	item.menu = item.menu || [];
      // 	// where to insert
      //   item.menu.push(dragObj);
      // });
    } else if (
      (info.node.props.children || []).length > 0 && // Has children
      info.node.props.expanded && // Is expanded
      dropPosition === 1 // On the bottom gap
    ) {
      loop(data, dropKey, (item) => {
        item.children = item.children || [];
        item.children.unshift(dragObj);
      });

      // loopMenu(data, dropKey, (item) => {
      // 	item.menu = item.menu || [];
      // 	item.menu.unshift(dragObj);
      // });
    } else {
      let ar;
      let i;

      // let arm;
      // let im;
      loop(data, dropKey, (item, index, arr) => {
        ar = arr;
        i = index;
      });

      // loopMenu(data, dropKey, (item, index, arr) => {
      // 	arm = arr;
      // 	im = index;
      // });

      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }

      // if (dropPosition === -1) {
      // 	arm.splice(im, 0, dragObj);
      // } else {
      // 	arm.splice(im + 1, 0, dragObj);
      // }
    }

    // if (!isUpdateHasChild) {
    // 	return null;
    // }

    setMenus(data);
  };

  const onSelectMenu = async (selectedKeys, { selectedNodes }) => {
    if (selectedNodes && selectedKeys) {
      const selected = selectedNodes[0];
      if (selected) {
        if (selected.templateId) {
          await getTemplateById(selected.templateId);
        } else {
          setTemplate({ mainTitle: { titleTH: null } });
        }
        setSelectedKeys(selectedKeys);
      } else {
        setSelectedKeys([]);
      }

      setCurrentMenuType(selected?.menuType);
      setSelected(selected);

      onSelectedMenuToForm(selected);
    }
  };

  const getTemplateById = async (id) => {
    try {
      dispatch(appLoaderAction.enable());
      const obj = await templateContentService.getById({ id: id });
      setTemplate(obj.bean);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const onSelectedMenuToForm = (selected) => {
    if (form) {
      form.resetFields();
    }

    if (selected) {
      form.setFieldsValue({
        title: selected.title,
        titleTH: selected?.menuTitle?.titleTH,
        titleEN: selected?.menuTitle?.titleEN,
        menuType: selected.menuType,
        url: selected.url,
        templateId: selected.templateId,
        status: selected.status === "true" || selected.status,
      });
    } else {
      setCurrentMenuType(null);
    }
  };

  const onHandleValue = (name) => {
    return (e) => {
      const newMenus = [...menus];
      loop(newMenus, selected.key, (item) => {
        setValue(e, item, name);
        item.menuName = item.title;
        item.menuUrl = item.urlSuffix;
      });

      setMenus(newMenus);
    };
  };

  const setValue = (e, item, name) => {
    if (e.target) {
      if (e.target.value !== undefined) {
        const { value } = e.target;
        if (name === "titleTH") {
          item["menuTitle"].titleTH = value;
          item["title"] = value;
        } else if (name === "titleEN") {
          item["menuTitle"].titleEN = value;
        } else {
          item[name] = value;
        }
      } else if (e.target.checked !== undefined) {
        const { checked } = e.target;
      }
    } else {
      const value = e;
      item[name] = value;

      if (name === "menuType") {
        setCurrentMenuType(value);
      }
    }
  };

  const renderTreeMenu = (groupMenu) => {
    return (
      <div>
        <Button type="primary" className="w-100" onClick={onAddMenu}>
          <Icon.Plus className="me-1" size={18} /> เพิ่มเมนู
        </Button>
        <h5 className="color-primary mt-3 mb-2">รายการเมนู </h5>
        <div className="boder-main">
          {menus && menus.length > 0 ? (
            <Tree
              key={"tree-menu" + groupMenu}
              className="draggable-tree"
              defaultExpandAll={true}
              draggable
              blockNode
              onDragEnter={onDragEnter}
              onDrop={onDrop}
              selectedKeys={selectedKeys}
              treeData={menus}
              onSelect={onSelectMenu}
            />
          ) : null}
        </div>
      </div>
    );
  };

  const onCurrentMenuTypeChange = () => {
    return (value) => {
      setCurrentMenuType(value);
    };
  };

  const onSelectAutoComplete = (value) => {
    // console.log("onSelect", value);
  };

  const handleSearch = (value) => {
    // console.log('handleSearch ', value);
    doGetContentList(value);
  };

  const fetchContent = async (keyword) => {
    try {
      const newPaginate = {
        ...pagination,
        currentPage: 1,
      };

      const newCondition = { title: keyword };
      const result = await templateContentService.search(
        newCondition,
        newPaginate
      );
      const newResult = result.list.map((item) => {
        return {
          ...item,
          value: item.templateId,
          label: item.mainTitle.titleTH,
          key: item.templateId,
        };
      });

      return newResult;
    } catch (err) {
      dispatch(notifyUtitls.error(err));
    }
  };

  const renderSelectedMenu = (groupMenu) => {
    return (
      <div key={"selected-menu" + groupMenu}>
        {selected ? (
          <Form
            layout="vertical"
            name="add_edit_menu"
            preserve={false}
            form={form}
            validateMessages={{
              required: "กรุณาระบุ",
            }}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={"ชื่อเมนูภาษาไทย"}
                  name="titleTH"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input onChange={onHandleValue("titleTH")} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item label={"ชื่อเมนูภาษาอังกฤษ"} name="titleEN">
                  <Input onChange={onHandleValue("titleEN")} />
                </Form.Item>
              </Col>
              {!selected.children ||
              (selected.children && selected.children.length == 0) ? (
                <Col span={12}>
                  <Form.Item
                    label="ประเภท"
                    initialValue="URL"
                    name="menuType"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      onChange={onHandleValue("menuType")}
                      value={currentMenuType}
                    >
                      <Option value="">โปรดระบุ</Option>
                      {renderMenuType()}
                    </Select>
                  </Form.Item>
                </Col>
              ) : null}
              {!selected.children ||
              (selected.children && selected.children.length == 0) ? (
                <Col span={24}>
                  {currentMenuType === "URL" ? (
                    <Form.Item
                      name="url"
                      label="URL"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input onChange={onHandleValue("url")} />
                    </Form.Item>
                  ) : (
                    <Form.Item
                      name="templateId"
                      label="เนื้อหา"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      {/* <Select 
                        onChange={onHandleValue('templateId')} 
                        showSearch
                        filterOption={false}
                        onSearch={handleSearch}
                        placeholder="พิมพ์เพื่อค้นหา"
                        fetchOptions={fetchContent}>
                      </Select> */}
                      <DebounceSelect
                        onChange={onHandleValue("templateId")}
                        showSearch
                        filterOption={false}
                        value={{
                          value: selected.templateId,
                          label: template.mainTitle.titleTH,
                        }}
                        placeholder="พิมพ์เพื่อค้นหา"
                        fetchOptions={fetchContent}
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    label="สถานะ"
                    name="status"
                    valuePropName="checked"
                  >
                    <Switch onChange={onHandleValue("status")} />
                  </Form.Item>
                </Col>
              ) : null}

              <Col span={24}>
                <div className="d-flex justify-content-between">
                  <div>
                    <Button type="primary" onClick={onSaveMenu}>
                      <Icon.Save className="me-2" size={17} />
                      บันทึกเมนู
                    </Button>

                    <Popconfirm
                      title="ยืนยันการลบข้อมูล ?"
                      onConfirm={() => onRemoveMenu()}
                      okText="ยืนยัน"
                      cancelText="ยกเลิก"
                    >
                      <Button type="primary" danger className="mx-2">
                        <Icon.Trash size={17} className="me-2" />
                        ลบเมนู
                      </Button>
                    </Popconfirm>
                  </div>
                  {/*               <div>
                    <Button className="mx-2 btn-line" onClick={() => onPreview()}>
                      <Icon.Eye className="me-1" size={18} /> ดูตัวอย่างเว็บไซต์
                    </Button>
                  </div> */}
                </div>
              </Col>
            </Row>
          </Form>
        ) : (
          <Empty />
        )}
      </div>
    );
  };

  const renderMenuType = () => {
    return menuType.map(({ value, labelTh }) => (
      <Option value={value} key={value}>
        {labelTh}
      </Option>
    ));
  };

  const renderContentList = () => {
    return contentList.map(({ templateId, mainTitle }) => (
      <Option value={templateId} key={templateId} text={mainTitle.titleTH}>
        {mainTitle.titleTH ? mainTitle.titleTH : mainTitle.titleEN}
      </Option>
    ));
  };

  const onChangeTab = (key) => {
    setCondition(key);
    setSelected(null);
    doGetContentList(null);
    if (form) {
      form.resetFields();
    }
  };

  return (
    <div>
      <h2 className="color-primary-title">เมนู</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการเนื้อหา</Breadcrumb.Item>
        <Breadcrumb.Item>เมนู</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <Tabs className="tabs-own" defaultActiveKey="1" onChange={onChangeTab}>
        <TabPane tab="บุคลากร" key="PERSONNEL">
          <Row gutter={16}>
            <Col span={8}>
              <Card bordered={false}>{renderTreeMenu("PERSONNEL")}</Card>
            </Col>
            <Col span={16}>
              <Card bordered={false}>{renderSelectedMenu("PERSONNEL")}</Card>
            </Col>
          </Row>
        </TabPane>

        <TabPane tab="ศิษย์เก่า" key="ALUMI">
          <Row gutter={16}>
            <Col span={8}>
              <Card bordered={false}>{renderTreeMenu("ALUMI")}</Card>
            </Col>
            <Col span={16}>
              <Card bordered={false}>{renderSelectedMenu("ALUMI")}</Card>
            </Col>
          </Row>
        </TabPane>

        <TabPane tab="นักศึกษาปัจจุบัน" key="COLLEGIAN">
          <Row gutter={16}>
            <Col span={8}>
              <Card bordered={false}>{renderTreeMenu("COLLEGIAN")}</Card>
            </Col>
            <Col span={16}>
              <Card bordered={false}>{renderSelectedMenu("COLLEGIAN")}</Card>
            </Col>
          </Row>
        </TabPane>

        <TabPane tab="ประชาชน" key="GENERAL">
          <Row gutter={16}>
            <Col span={8}>
              <Card bordered={false}>{renderTreeMenu("GENERAL")}</Card>
            </Col>
            <Col span={16}>
              <Card bordered={false}>{renderSelectedMenu("GENERAL")}</Card>
            </Col>
          </Row>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default MenuManagement;
